<div class="card parentcard p-4 d-flex flex-column">
  <header class="row mb-4">
    <div class="col-12">
      <h6 class="mb-0">
        <strong>Step 5:</strong>
        <span class="ms-2">Review Python Scripts</span>
      </h6>
      <hr class="mt-2 mb-4">
    </div>
  </header>

  <!-- Main content area that will grow to fill space -->
  <main class="row g-4 px-2 flex-grow-1">
    <!-- Script Panels -->
    <section class="col-md-8 d-flex flex-column">
      <label for="pythonScriptArea" class="form-label fw-bold mb-3">
        Generated Python Script
      </label>
      <textarea
        [(ngModel)]="pythonScript"
        class="form-control font-monospace flex-grow-1"
        id="pythonScriptArea"
        placeholder="Generated Python code will appear here"
        [disabled]="!isEditMode"
        aria-label="Python script editor"
        spellcheck="false"
      ></textarea>
    </section>

    <section class="col-md-4 d-flex flex-column">
      <label for="aiScriptArea" class="form-label fw-bold mb-3">
        Auto Generated Validation Report
      </label>
      <textarea
        [(ngModel)]="aiScript"
        class="form-control font-monospace flex-grow-1 bg-light"
        id="aiScriptArea"
        placeholder="AI validation report will appear here"
        [disabled]="!isEditMode"
        aria-label="AI validation report"
        readonly
        spellcheck="false"
      ></textarea>
    </section>
  </main>

  <!-- Controls Section - Fixed at bottom -->
  <footer class="row mt-4 px-2">
    <div class="col-12">
      <!-- Checkboxes stacked vertically -->
      <div class="mb-4">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="autofixCheck"
            (change)="onAutofixChange($event)"
            [checked]="autofixEnabled"
            aria-describedby="autofixHelp"
          />
          <label class="form-check-label d-flex align-items-center gap-2" for="autofixCheck">
            <span class="fw-semibold">Autofix using AI</span>
            <i class="bi bi-magic text-primary cursor-pointer"
               ngbTooltip="Automatically detect and fix potential issues in the AI generated script while execution."
               placement="bottom"
               container="body"
               triggers="hover focus"></i>
          </label>
        </div>

        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="riskAcknowledgment"
            (change)="onAgreeChange($event)"
          />
          <label class="form-check-label text-danger fw-semibold" for="riskAcknowledgment">
            I understand and accept all risks associated with executing the AI generated script.
          </label>
        </div>
      </div>

      <!-- Action Buttons fixed at the bottom -->
      <div class="d-flex flex-wrap justify-content-end gap-3">
        <button class="btn btn-outline-primary" (click)="toggleEditMode()">
          {{ isEditMode ? "Save Changes" : "Edit Scripts" }}
          <i class="bi ms-2" [ngClass]="isEditMode ? 'bi-save' : 'bi-pencil-square'"></i>
        </button>

        <button
          class="btn btn-outline-secondary"
          (click)="regenerateCode()"
          [disabled]="regenerateDisabled"
        >
          Regenerate
          <i class="bi-arrow-clockwise ms-2"></i>
        </button>

        <button
          class="btn btn-success"
          (click)="PreviewPage()"
          [disabled]="generateDataDisabled"
        >
          Generate Data
          <i class="bi-play-circle ms-2"></i>
        </button>
      </div>
    </div>
  </footer>

  <!-- Toast Container -->
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1100">
    <ngb-toast
      *ngFor="let toast of toastService.getToasts()"
      [autohide]="toast.options?.autohide ?? true"
      [delay]="toast.options?.delay ?? 5000"
      [class]="toast.options?.classname"
      (hidden)="toastService.remove(toast)"
    >
      <ng-template [ngIf]="toastService.isTemplate(toast)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
      </ng-template>
      <ng-template #text>{{ toast.textOrTpl }}</ng-template>
    </ngb-toast>
  </div>
</div>